var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ClientUserTable',{attrs:{"userList":_vm.userList,"pageLoader":_vm.pageLoader,"error":_vm.error,"type":"client","clientId":_vm.clientInfo.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }